// extracted by mini-css-extract-plugin
module.exports = {"Sticker":"style_Sticker__3bbEP","Sticker_mobile":"style_Sticker_mobile__3nKFy","Sticker__Content":"style_Sticker__Content__2MdaO"};